import React from 'react'

import { mapToComponent, CommonProps } from './styles'

interface Props extends CommonProps {
  tag: keyof typeof mapToComponent
  style?: any,
  className?: string,
}

const Text: React.FC<Props> = ({ children, color, align, tag = 'span', size, style, className }) => {
  const C = mapToComponent[tag]
  return (
    <C
      className={className}
      color={color}
      align={align}
      size={size}
      style={style}
    >
      {children}
    </C>
  )
}

export default Text
